import Swiper from 'swiper';
import { Animation } from '../components/animation';

export function blogPage() {
    const animation       = new Animation;
    const articlesWrapper = document.querySelector('.js-otherPublicationBlockList');
    const $categoryItems  = document.getElementsByClassName('js-categoryItem');
    const $goTop          = document.getElementsByClassName('js-goTop');
    const pageType        = location.pathname === '/blog' ? 'blog' : location.pathname === '/' ? 'main' : 'publication';
    const initTagId       = location.hash.match(/tag=(\d+)/) === null ? 0 : parseInt(location.hash.match(/tag=(\d+)/)[1], 10);
    let sliderCategory;

    /**
     * Показываем название выбранной категории
     */
    function showActiveCategoryBlock(args) {
        const $activeCategoryBlock = document.querySelector('.js-activeCategoryBlock');
        const $activeCategory      = document.querySelector('.js-activeCategory');
        const $resetCategory       = document.querySelector('.js-resetCategory');

        $activeCategoryBlock.classList.toggle('is-active', args.show)

        if (args.show) {
            $resetCategory.style.display = 'block';
        } else {
            $resetCategory.style.display = 'none';
        }

        if (args.textContent) {
            $activeCategory.textContent = args.textContent;
        }
    }

    /**
     * Отмечаем выбранный тег
     */
    function selectTag(selected_tag_id) {
        [...$categoryItems].forEach($item => {
            $item.classList.toggle('is-active', parseInt($item.dataset.tag_id, 10) === parseInt(selected_tag_id, 10))
        });
    }

    /**
     * Показываем/скрываем многоточие к тегам карточек
     */
    function showTags() {
        const cardCategoryList = document.querySelectorAll('.js-cardCategoryList');
        const cardCount        = 1;

        cardCategoryList.forEach(block => {
            let cardCategory = block.querySelectorAll('.js-cardCategory');

            if (cardCategory.length > cardCount) {
                let showAllCardCategory = block.querySelector('.js-showAllCardCategory');
                showAllCardCategory.classList.add('is-active');

                cardCategory.forEach( (item, index) => {

                    if (item.dataset.url) {
                        item.addEventListener('click', e => {
                            window.location.href = item.dataset.url;
                        });
                    }

                    item.classList.remove('is-hidden');

                    if (index > cardCount - 1) {
                        item.classList.add('is-hidden');
                    }
                });

                showAllCardCategory.addEventListener('click', e => {
                    e.preventDefault();
                    e.stopPropagation();

                    cardCategory.forEach( item => {
                        showAllCardCategory.classList.remove('is-active');
                        item.classList.remove('is-hidden');
                    });
                });
            }
        });
    }

    /**
     * Клик по тегам
     */
    function cardTagClick($tag) {
        // страница статьи
        if ($tag.dataset.url) {
            location.href = $tag.dataset.url;
            return;
        }

        // страница блога
        if (location.pathname === '/blog') {
            const selected_tag_id = typeof $tag.dataset.tag_id === 'undefined' ? 0 : $tag.dataset.tag_id;
            const textContent     = $tag.textContent;

            getArticles({
                selected_tag_id: selected_tag_id,
                callback: function(render, show_more) {
                    articlesWrapper.innerHTML = render;

                    // показываем/скрываем кнопку показать еще
                    if (!show_more && document.querySelector('.js-showMorePublications')) {
                        document.querySelector('.js-showMorePublications').style.display = 'none';
                    }

                    // отмечаем выбранный тег
                    selectTag(selected_tag_id);

                    if (pageType === 'blog') {
                        showActiveCategoryBlock({show: 1, textContent});

                        if ($tag.classList.contains('js-goTop')) {
                            const fixidHeight  = document.querySelector('[am-fixed]').clientHeight,
                                  headerHeight = fixidHeight > 80 ? 200 : 145;

                            // прокрутка к началу страницы
                            animation.scroll(articlesWrapper.parentNode, headerHeight, 400);

                            // перемотка слайдера к выбранной категории
                            document.querySelectorAll('.category-slide').forEach(($item, index) => {
                                if ($item.dataset.tag_id === $tag.dataset.tag_id) {
                                    sliderCategory.slideTo(index)
                                }
                            });
                        }
                    }
                }
            });
            return;
        }
    }

    /**
     * Подгрузка карточек
     */
    function loadPublications($button) {
        const exclude_page_ids = [];

        // другие публикации
        [...$button.parentNode.getElementsByClassName('js-publicationCard')].forEach($item => exclude_page_ids.push($item.dataset.tag_id));

        // выбранный тег

        // получаем данные
        getArticles({
            page_id: document.body.dataset.page_id,
            exclude_page_ids,
            callback: function(render, show_more) {
                if ($button.classList.contains('js-resetCategory')) {
                    articlesWrapper.innerHTML = render;
                } else {
                    articlesWrapper.innerHTML += render;
                }

                if (!show_more) {
                    $button.style.display = 'none';
                }

                // ставим многоточие к тегам
                showTags();

                if (pageType === 'blog') {
                    // отмечаем выбранный тег
                    selectTag(0);

                    showActiveCategoryBlock({show: 0});
                }
            }
        });
    }

    /**
     * AJAX метод подгрузки карточек
     */
    function getArticles(args) {
        const {page_id = 0, selected_tag_id = 0, exclude_page_ids = [], callback = function(){}} = args;

        const formData = new FormData();
              formData.append('page_id', page_id);
              formData.append('selected_tag_id', selected_tag_id);
              formData.append('exclude_page_ids', exclude_page_ids);
              formData.append('page_type', pageType);

        articlesWrapper.parentNode.classList.add('is-loading');

        fetch('/handler/get_articles ', {
            method: 'POST',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            },
            body: formData,
        })
        .then(response => response.json())
        .then(r => {
            setTimeout(() => {
                if (r.status == 'ok') {
                    callback(r.render, r.show_more);
                } else {
                    callback('По выбранной рубрике статей на данный момент нет, но в ближайшее время мы их добавим.');
                }

                articlesWrapper.parentNode.classList.remove('is-loading');
                showTags();
            }, 1000);
        });
    }

    /**
     * Инициализация
     */
    function init() {
        sliderCategory = new Swiper('.category-slider', {
            containerModifierClass: 'category-slider',
            wrapperClass: 'category-slider__wrapper',
            slideClass: 'category-slide',
            slidesPerView: 'auto',
            simulateTouch: true,
            scrollbar: {
                el: '.category-scrollbar',
                draggable: true,
                hide: true,
            },
            navigation: {
                nextEl: '.category-button-next',
                prevEl: '.category-button-prev',
            },
            on: {
                init: function() {
                    let self = this;
                    setTimeout(function() {
                        self.update();
                    }, 1000);
                }
            }
        });

        showTags();

        /**
         * Общий обработчик кликов
         */
        document.addEventListener('click', function(e) {
            // подгрузка карточек на странице статьи
            if (e.target.classList.contains('js-loadPublications')) {
                return loadPublications(e.target);
            }

            // клик по тегу
            if (e.target.classList.contains('js-categoryItem')) {
                e.preventDefault();
                e.stopPropagation();

                return cardTagClick(e.target);
            }

            // клик по кнопке показать еще
            if (e.target.classList.contains('js-showMorePublications')) {
                return loadPublications(e.target);
            }

            // сброс выбранного тега
            if (e.target.classList.contains('js-resetCategory')) {
                return loadPublications(e.target);
            }
        });

        ['resize', 'orientationChange'].forEach(item => {
            window.addEventListener(item, showTags);
        });

        const $initTag = document.querySelector('.js-categoryItem[data-tag_id="' + initTagId + '"]');
        if (initTagId > 0 && $initTag !== null) {
            cardTagClick($initTag);
        }
    }
    init();
}